import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql-error-processor';

import { getTrialDaysLeftFromQuery } from '../../graphql/getTrialDaysLeftFromQuery';

export const useReverseTrialLozengeExperimentTrialDetails = (skip: boolean = false) => {
	const { data, error, loading } = useQuery(
		gql`
			query useReverseTrialLozengeExperimentTrialDetailsQuery {
				license {
					billingSourceSystem
					trialEndDate
				}
			}
		`,
		{
			fetchPolicy: 'cache-first',
			skip,
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	return {
		error,
		loading,
		daysLeft: getTrialDaysLeftFromQuery(data),
		billingSourceSystem: data?.license?.billingSourceSystem,
	};
};
